module.exports = __webpack_public_path__ + "static/media/signed2.7ff1b5e4.png";